export enum ColorSchemeUIDs {
  VIOLET = "violet",
  BLACK = "black",
  FOREST_GREEN = "forest-green",
  TEAL = "cs-teal",
  BLUE = "cs-blue",
  PINK = "cs-pink",
}
